import { ApolloClient, InMemoryCache, ApolloCache } from '@apollo/client';
import { APP_VERSION } from 'config/constants';
import { link } from './links';
import { dataIdFromObject, typePolicies } from './cacheConfig';

const cache: ApolloCache<any> = new InMemoryCache({
  typePolicies,
  dataIdFromObject,
});

// Configure the ApolloClient with the default cache
const client: ApolloClient<any> = new ApolloClient({
  name: 'workspace',
  version: APP_VERSION,
  link,
  cache,
  // This speeds up the initial load by 30%
  assumeImmutableResults: true,
});

export { client, cache };
